module.exports = __webpack_public_path__ + "img/vertical_4_5_3016.1e4f439a.png";